export default {
    getAuctionItems (state) {
        return state.auctionItem
    },
    getServerTime (state) {
        return state.serverTime
    }
}